import api from "./api"

const apiDaftarHadir = {
    getByFilter:(data:any) => {
        return api.post(`/ptk/absensi/daftar-kehadiran`, data)
    }
}

export default apiDaftarHadir